import classNames from 'classnames';
import { CcProductCardFeeIncomeCell } from './types';
import { CC_CARD_TEXT } from './utils';

type CcProductCardFeeIncomeProps = {
  annualFee: CcProductCardFeeIncomeCell | undefined;
  minIncome: CcProductCardFeeIncomeCell | undefined;
};

/** Tier 2 of the benefits block: annual fee at left, minimum income at right (FR-1.4.5). */
export const CcProductCardFeeIncome: React.FC<CcProductCardFeeIncomeProps> = ({
  annualFee,
  minIncome,
}) => (
  <div
    data-component="cc-product-card-fee-income"
    className="grid grid-cols-2 divide-x divide-borders/default"
  >
    {/* Each cell keeps its column, so a missing fee never slides the income to the left. */}
    <Cell cell={annualFee} />
    <Cell cell={minIncome} />
  </div>
);

const Cell: React.FC<{ cell: CcProductCardFeeIncomeCell | undefined }> = ({
  cell,
}) => {
  if (!cell) return <div />;

  return (
    <div className="flex min-w-0 flex-col gap-spacing/gap/soft-4px px-spacing/padding/x-sm py-2.5">
      <span
        className={classNames(
          CC_CARD_TEXT.label,
          'flex min-h-5 items-center text-text/secondary-lighter',
        )}
      >
        {cell.label}
      </span>
      {/* The same size as the earn rate: cost and eligibility weigh as much as the rate. */}
      <span
        className={classNames(
          CC_CARD_TEXT.headline,
          cell.isFree ? 'text-highlights/green-dark' : 'text-text/primary',
        )}
      >
        {cell.value}
      </span>
      {cell.caption && (
        <span
          className={classNames(
            CC_CARD_TEXT.note,
            'text-text/secondary-lighter',
          )}
        >
          {cell.caption}
        </span>
      )}
    </div>
  );
};
